import { FieldGuesser, InputGuesser, ListGuesser, ShowGuesser } from '@api-platform/admin'
import React from 'react'
import {
    Create as BaseCreate,
    Edit as BaseEdit,
    required,
    SaveButton,
    SimpleForm,
    Toolbar,
    useRecordContext,
    SelectInput,
} from 'react-admin'

const Title = () => {
    const record = useRecordContext()

    return <span>{record ? `${record?.email}` : ''}</span>
}

const EditToolbar = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
)

const InputFields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <SimpleForm toolbar={<EditToolbar />}>
            <InputGuesser label='First name' source='firstName' fullWidth isRequired validate={[required()]} />
            <InputGuesser label='Last name' source='lastName' fullWidth isRequired validate={[required()]} />
            <InputGuesser label='Email' source='email' fullWidth isRequired validate={[required()]} />
            <InputGuesser label='Actif' source='active' fullWidth isRequired validate={[required()]} />
            <InputGuesser label='Valid email ?' source='emailValid' fullWidth isRequired validate={[required()]} />
            <InputGuesser
                label='Valid phone number'
                source='phoneNumberValid'
                fullWidth
                isRequired
                validate={[required()]}
            />

            <SelectInput
                label='Role'
                source='roles'
                choices={[
                    { id: 'ROLE_USER', name: 'ROLE_USER' },
                    { id: 'ROLE_ADMIN', name: 'ROLE_ADMIN' },
                    { id: 'ROLE_MANAGER', name: 'ROLE_MANAGER' },
                ]}
                validate={[required()]}
            />
        </SimpleForm>
    </Guesser>
)

const Fields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <FieldGuesser label='Email' source='email' />
        <FieldGuesser label='First name' source='firstName' />
        <FieldGuesser label='Last name' source='lastName' />
        <FieldGuesser label='Actif' source='active' />
        <FieldGuesser label='Valid email ?' source='emailValid' />
        <FieldGuesser label='Valid phone number ?' source='phoneNumberValid' />
    </Guesser>
)

export const Create = (props) => <InputFields Guesser={BaseCreate} title={`CREATE`} {...props} />

export const Edit = (props) => <InputFields Guesser={BaseEdit} title={<Title />} {...props} />

export const Show = (props) => <Fields Guesser={ShowGuesser} title={<Title />} {...props} />

export const List = (props) => <Fields Guesser={ListGuesser} {...props} />

const CRUD = {
    list: List,
    edit: Edit,
    create: Create,
    show: Show,
}

export default CRUD
